import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import uaParserJs from 'ua-parser-js'


import Loader from './components/Loader.vue'

Vue.component('Loader', Loader);

Vue.prototype.$axios = axios;
Vue.prototype.$objectLength = function (object) {
    return Object.keys(object).length;
};

Vue.config.productionTip = false;

/* backdoor for test new brands */
let url = new URL(window.location.href);
let isBrand = url.searchParams.get('isBrand');
let isOpen = url.searchParams.get('open');
let yid = url.searchParams.get('yid');

/* get brand */
axios.get('//www.dsdashboardapi.com/api/index.php?action=brand&isBrand=' + isBrand, {
    withCredentials: true
}).then((result) => {
    loadStyle(result.data);
});
/* load style by brand + props the agent data */
function loadStyle(data) {
    let userAgent = uaParserJs.UAParser();
    new Vue({
        el: '#app',
        store,
        render(h) {
            return h(App, {
                props: {
                    brand: data.brand,
                    defaultExtensions: data.extensionDefault,
                    userAgent: userAgent,
                    isOpen:isOpen,
                    yid:yid
                }
            })
        }
    })
}
